<template>
  <div v-if="young.id" class="user-profile-sidebar" :class="{ 'show': shallShowYoungDetailsSidebar }">
    <young-details-header :young="young" :is-modifying="isModifying" @hide-sidebar="hideSideBar()" />
    <!-- Details -->
    <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="user-profile-sidebar-area scroll-area">
      <b-button v-if="canManageYoungsData" variant="outline-primary" class="mr-1 mb-2 w-100" @click="openModal()">
        <span class="ml-25 align-middle">
          Gestion des données
        </span>
      </b-button>
      <b-button v-if="canRequestAccommodation" variant="outline-primary" class="mr-1 mb-2 w-100" @click="openAccommodationModal()">
        <span class="ml-25 align-middle">
          Envoyer une demande d'hébergement
        </span>
      </b-button>
      <b-button v-if="canManageYoungsData && young.conversationStatus !== 4 && young.conversationStatus !== 5" variant="outline-warning" class="mr-1 mb-2 w-100" @click="openGdprArchiveModal()">
        <feather-icon icon="ArchiveIcon" size="15" class="mr-50" />
        <span class="ml-25 align-middle">Archiver le jeune (RGPD)</span>
      </b-button>
      <young-details-list v-if="!isModifying" :young="young" />
      <b-button v-if="!isModifying && canModify" variant="outline-primary" @click="setIsModifying">Modifier la
        fiche</b-button>
      <young-form v-else :young="young" @update-action="setIsModifying" />
      <div v-if="young.nameSakeIds && young.nameSakeIds.length > 0" class="name-sakes">
        <h6 class="section-label mb-1 mt-3">
          Homonymes
        </h6>
        <ul class="list-unstyled m-0">
          <li v-for="nameSakeId in young.nameSakeIds" :key="nameSakeId" class="mb-1">
            <a href="#" @click.prevent.stop="$emit('open-chat', nameSakeId)">
              Jeune {{ nameSakeId }}
            </a>
          </li>
        </ul>
      </div>
      <div v-if="young.users && young.users.length > 0 && young.users[0] !== null" class="users">
        <h6 class="section-label mb-1 mt-3">
          Intervenant(s)
        </h6>
        <ul class="list-unstyled m-0">
          <li v-for="user in young.users" :key="user" class="mb-1">
            {{ user }}
          </li>
        </ul>
      </div>
    </vue-perfect-scrollbar>
    <b-modal ref="modal" hide-header hide-footer title="Gestion des données" class="data-modal">
      <h2 class="text-primary text-center mb-2">
        Gestion des données
      </h2>
      <p v-if="modalMessage" class="text-center mb-2 text-success">
        {{ modalText }} effectué
      </p>
      <span v-if="isExtractDatasEvent" class="data-modal__subtext">Dernière extraction faite le : {{
        formatDate(extractDatasEvent.date) }} par {{ extractDatasEvent.userFirstName }} {{
        extractDatasEvent.userLastName }}</span>
      <span v-else class="data-modal__subtext">Données jamais extraites</span>
      <b-button variant="outline-primary" class="mr-1 mb-2 w-100 data-modal__button" @click="extractData">
        <span class="ml-25 align-middle">
          Extraire le journal d'interactions du jeune
        </span>
      </b-button>
      <span v-if="isTransferDataEvent" class="data-modal__subtext">Dernière données transmise le : {{
        formatDate(transferDataEvent.date) }} par {{ transferDataEvent.userFirstName }} {{
        transferDataEvent.userLastName }}</span>
      <span v-else class="data-modal__subtext">Données jamais transmises</span>
      <b-button variant="outline-primary" class="mr-1 mb-2 w-100 data-modal__button" @click="transferData">
        <span class="ml-25 align-middle">
          Transmettre les données
        </span>
      </b-button>
      <span v-if="isYoungAnonymize" class="data-modal__subtext">Dernière anonymisation le : {{
        formatDate(anonymizeEvent.date) }} par {{ anonymizeEvent.userFirstName }} {{ anonymizeEvent.userLastName }}</span>
      <span v-else class="data-modal__subtext">Jeune non anonymisé</span>
      <b-button variant="outline-primary" class="mr-1 mb-2 w-100 data-modal__button" @click="anonymize">
        <span class="ml-25 align-middle">
          {{ isYoungAnonymize ? 'Ré-anonymiser le jeune' : 'Anonymiser le jeune' }}
        </span>
      </b-button>
      <p v-if="openConfirmationAnonymization" class="text-center text-danger">
        Voulez-vous vraiment anonymisé les données ?
      </p>
      <div v-if="openConfirmationAnonymization" class="data-modal__delete-confirm ">
        <b-button variant="danger" @click="cancelAnonymization">
          Annuler
        </b-button>
        <b-button variant="primary" @click="confirmAnonymization">
          Confirmer
        </b-button>
      </div>
      <b-button variant="outline-primary" class="mr-1 mb-2 w-100 data-modal__button data-modal__button-remove"
                @click="deleteData">
        <span class="ml-25 align-middle">
          Supprimer les données
        </span>
      </b-button>
      <p v-if="openConfirmationDeletion" class="text-center text-danger">
        Voulez-vous vraiment supprimer les données ?
      </p>
      <div v-if="openConfirmationDeletion" class="data-modal__delete-confirm ">
        <b-button variant="danger" @click="cancelDeletion">
          Annuler
        </b-button>
        <b-button variant="primary" @click="confirmDeletion">
          Confirmer
        </b-button>
      </div>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" class="mr-2 data-modal__back-button" @click="closeModal()">
          Annuler
        </b-button>
      </div>
    </b-modal>
    <b-modal ref="modalDeletion" hide-header hide-footer title="Gestion des données" class="data-modal">
      <h2 class="text-primary text-center mb-2">
        Confirmation de Suppression de Données
      </h2>
      <p class="text-center mb-2 text-danger">
        Avertissement : Suppression de Données Définitive
      </p>
      <p class="text-center ">
        Cher(e) utilisateur(trice),
        Vous êtes sur le point d'effectuer une opération de suppression de données qui est irréversible. Veuillez
        prendre un moment pour lire attentivement les informations suivantes :
      </p>
      <ul>
        <li>
          <span class="font-weight-bold">Irréversibilité :</span> Cette action de suppression est permanente. Toutes les
          données sélectionnées seront définitivement effacées de notre système et ne pourront pas être récupérées.
        </li>
        <li>
          <span class="font-weight-bold">Aucune Restauration Possible :</span> Après la suppression, il ne sera pas
          possible de restaurer ou de récupérer les données supprimées. Soyez certain(e) que vous n'avez plus besoin de
          ces données ou que vous disposez d'une copie de sauvegarde appropriée, le cas échéant.
        </li>
      </ul>
      <p class="text-center">
        Si vous comprenez les conséquences de cette suppression définitive et que vous souhaitez la poursuivre, cliquez
        sur le bouton "Confirmer la Suppression" ci-dessous.
      </p>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" class="mr-2 data-modal__back-button" @click="closeModalConfirmation()">
          Annuler
        </b-button>
        <b-button variant="primary" class="mr-2 data-modal__back-button" @click="finalConfirmDeletion()">
          Confirmer la suppression
        </b-button>
      </div>
    </b-modal>
    <b-modal ref="modalGdprArchive" hide-header hide-footer title="Archiver le jeune (RGPD)" class="data-modal">
      <h2 class="text-primary text-center mb-2">
        Archiver le jeune (RGPD)
      </h2>
      <p class="text-center text-danger">
        Vous êtes sur le point d'archiver <strong>{{ young.firstName }} {{ young.lastName }}</strong> au titre du RGPD.
      </p>
      <p class="text-center">
        Cette action déplace le jeune dans la file d'archivage RGPD et déclenche le délai de rétention légal.
        Cette opération est irréversible sauf si le jeune reprend contact.
      </p>
      <div class="d-flex justify-content-end mt-2">
        <b-button variant="danger" class="mr-2" @click="closeGdprArchiveModal()">
          Annuler
        </b-button>
        <b-button variant="primary" :disabled="isArchivingGdpr" @click="confirmGdprArchive()">
          Confirmer l'archivage
        </b-button>
      </div>
    </b-modal>
    <b-modal ref="modalAccommodation" hide-header hide-footer title="Demande d'hébergement" class="data-modal" @hidden="resetAccommodationState">
      <h2 class="text-primary text-center mb-2">
        Demande d'hébergement
      </h2>
      <p v-if="accommodationSuccess" class="text-center mb-2 text-success">
        La demande d'hébergement a été créée avec succès !
      </p>
      <p v-else class="text-center">
        Voulez-vous envoyer une demande d'hébergement pour <strong>{{ young.firstName }} {{ young.lastName }}</strong> ?
      </p>
      <span v-if="isAccommodationRequestEvent" class="data-modal__subtext">Dernière demande envoyée le : {{
        formatDate(accommodationRequestEvent.date) }} par {{ accommodationRequestEvent.userFirstName }} {{
        accommodationRequestEvent.userLastName }}</span>
      <span v-else class="data-modal__subtext">Aucune demande d'hébergement envoyée</span>
      <div v-if="!accommodationSuccess">
        <p class="text-center text-muted" style="font-size: 0.9rem; margin-top: 1rem;">
          Un email sera envoyé au coordinateur avec les informations du jeune.
        </p>
        <b-form-group label="Informations complémentaires (optionnel)" label-for="accommodation-request-comment" class="mt-1">
          <b-form-textarea
            id="accommodation-request-comment"
            v-model="accommodationRequestComment"
            placeholder="Ajoutez des précisions sur la demande d'EP..."
            rows="3"
            max-rows="6"
            :disabled="isSendingAccommodation"
          />
          <small class="text-muted">Ce commentaire sera inclus dans l'email mais ne sera pas enregistré.</small>
        </b-form-group>
        <div class="d-flex justify-content-end mt-1">
          <b-button variant="danger" class="mr-2" @click="closeAccommodationModal()">
            Annuler
          </b-button>
          <b-button variant="primary" :disabled="isSendingAccommodation" @click="sendAccommodationRequest()">
            <span v-if="isSendingAccommodation">
              <b-spinner small class="mr-1" />
              Envoi en cours...
            </span>
            <span v-else>Confirmer l'envoi</span>
          </b-button>
        </div>
      </div>
      <div v-else class="d-flex justify-content-end">
        <b-button variant="primary" @click="closeAccommodationModal()">
          Fermer
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BSpinner,
  BFormTextarea,
  BFormGroup,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import { formatDate, formatPhoneNumber } from '@core/utils/filter'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import departements from '@/assets/departments.json'
import store from '@/store'
import YoungDetailsList from './YoungDetailsList.vue'
import YoungForm from './YoungForm.vue'
import YoungDetailsHeader from './YoungDetailsHeader.vue'

export default {
  components: {
    BButton,
    BSpinner,
    BFormTextarea,
    BFormGroup,
    VuePerfectScrollbar,
    YoungDetailsList,
    YoungForm,
    YoungDetailsHeader,
    BModal,
  },
  props: {
    shallShowYoungDetailsSidebar: {
      type: Boolean,
      required: true,
    },
    young: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const modalMessage = ref(false)
    const modalText = ref('')
    const openConfirmationDeletion = ref(false)
    const openConfirmationAnonymization = ref(false)
    const modal = ref(null)
    const modalDeletion = ref(null)
    const modalAccommodation = ref(null)
    const accommodationSuccess = ref(false)
    const isSendingAccommodation = ref(false)
    const isArchivingGdpr = ref(false)
    const accommodationRequestComment = ref('')
    const isAccommodationRequestEvent = ref(false)
    const isYoungAnonymize = ref(false)
    const isExtractDatasEvent = ref(false)
    const isTransferDataEvent = ref(false)

    const anonymizeEvent = computed(() => store.getters['events/eventYoungAnonymize'])
    const extractDatasEvent = computed(() => store.getters['events/eventYoungExtractDatas'])
    const transferDataEvent = computed(() => store.getters['events/eventYoungTransferData'])
    const accommodationRequestEvent = computed(() => store.getters['events/eventAccommodationRequest'])
    const excelDatas = computed(() => store.getters['youngs/excelDatas'])
    const zipDatas = computed(() => store.getters['youngs/zipDatas'])

    const dispatchEvent = async (event, younId) => {
      try {
        await store.dispatch(`events/${event}`, { youngId: younId })
        return true
      } catch (error) {
        if (error.response.status === 404) {
          return false
        }
        throw error
      }
    }

    const openModal = async () => {
      isYoungAnonymize.value = await dispatchEvent('fetchEventYoungAnonymize', props.young.id)
      isExtractDatasEvent.value = await dispatchEvent('fetchEventYoungExtractDatas', props.young.id)
      isTransferDataEvent.value = await dispatchEvent('fetchEventYoungTransferData', props.young.id)

      modal.value.show()
    }

    const closeModal = () => {
      modal.value.hide()
      modalMessage.value = false
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    const getFileLink = (file, fileName) => {
      const url = window.URL.createObjectURL(file)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    const extractData = async () => {
      await store.dispatch('youngs/fetchExcelDatas', props.young.id)
      const file = excelDatas.value
      const fileName = `young_datas_${props.young.lastName}_${props.young.firstName}.xlsx`
      getFileLink(file, fileName)
      await store.dispatch('events/fetchEventYoungExtractDatas', { youngId: props.young.id })
      isExtractDatasEvent.value = true
    }

    const transferData = async () => {
      await store.dispatch('youngs/fetchZipDatas', props.young.id)
      const file = zipDatas.value
      const fileName = `young_datas_${props.young.lastName}_${props.young.firstName}.zip`
      getFileLink(file, fileName)
      await store.dispatch('events/fetchEventYoungTransferData', { youngId: props.young.id })
      isTransferDataEvent.value = true
    }

    const anonymize = async () => {
      openConfirmationAnonymization.value = true
    }

    const confirmAnonymization = async () => {
      modalMessage.value = false
      modalText.value = 'Anonymisation des données'
      await store.dispatch('users/anonymizeYoung', props.young.id)
      isYoungAnonymize.value = true
      await store.dispatch('events/fetchEventYoungAnonymize', { youngId: props.young.id })
      modalMessage.value = true
      openConfirmationAnonymization.value = false
    }

    const cancelAnonymization = () => {
      openConfirmationAnonymization.value = false
    }

    const deleteData = () => {
      openConfirmationDeletion.value = true
    }

    const cancelDeletion = () => {
      openConfirmationDeletion.value = false
    }

    const confirmDeletion = async () => {
      modalMessage.value = false
      openConfirmationDeletion.value = false
      modalDeletion.value.show()
    }

    const finalConfirmDeletion = async () => {
      modalMessage.value = false
      await store.dispatch('youngs/deleteYoung', props.young.id)
      openConfirmationDeletion.value = false
      modalDeletion.value.hide()
      modal.value.hide()
    }

    const closeModalConfirmation = () => {
      modalDeletion.value.hide()
    }

    const toast = useToast()
    const displayToast = (title, icon, mode) => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          position: 'bottom-right',
          icon,
          variant: mode,
        },
      })
    }

    const modalGdprArchive = ref(null)

    const openGdprArchiveModal = () => {
      modalGdprArchive.value.show()
    }

    const closeGdprArchiveModal = () => {
      modalGdprArchive.value.hide()
    }

    const confirmGdprArchive = async () => {
      if (isArchivingGdpr.value) { return }

      isArchivingGdpr.value = true
      try {
        await store.dispatch('youngs/gdprArchiveYoung', props.young.id)
        modalGdprArchive.value.hide()
        displayToast('Jeune archivé (RGPD) avec succès', 'ArchiveIcon', 'success')
      } finally {
        isArchivingGdpr.value = false
      }
    }

    const openAccommodationModal = async () => {
      accommodationSuccess.value = false
      isAccommodationRequestEvent.value = await dispatchEvent('fetchEventAccommodationRequest', props.young.id)
      modalAccommodation.value.show()
    }

    const closeAccommodationModal = () => {
      modalAccommodation.value.hide()
    }

    const resetAccommodationState = () => {
      accommodationSuccess.value = false
      accommodationRequestComment.value = ''
    }

    const sendAccommodationRequest = async () => {
      if (isSendingAccommodation.value) { return }

      isSendingAccommodation.value = true
      try {
        const response = await store.dispatch('youngs/sendAccommodationRequest', { youngId: props.young.id, accommodationRequestComment: accommodationRequestComment.value })
        accommodationSuccess.value = true
        displayToast('Demande d\'hébergement créée avec succès', 'CheckIcon', 'success')
        if (!response?.data?.emailSent) {
          displayToast('L\'email au coordinateur n\'a pas pu être envoyé', 'AlertTriangleIcon', 'warning')
        }
        await store.dispatch('events/fetchEventAccommodationRequest', { youngId: props.young.id })
        isAccommodationRequestEvent.value = true
      } catch (error) {
        accommodationSuccess.value = false
        console.error('Erreur lors de l\'envoi de la demande d\'hébergement:', error)
        displayToast(
          'Erreur lors de la création de la demande d\'hébergement',
          'XCircleIcon',
          'danger',
        )
      } finally {
        isSendingAccommodation.value = false
      }
    }

    return {
      formatDate,
      formatPhoneNumber,
      perfectScrollbarSettings,
      extractData,
      transferData,
      isYoungAnonymize,
      anonymize,
      anonymizeEvent,
      isExtractDatasEvent,
      extractDatasEvent,
      isTransferDataEvent,
      transferDataEvent,
      openConfirmationAnonymization,
      cancelAnonymization,
      confirmAnonymization,
      deleteData,
      openConfirmationDeletion,
      cancelDeletion,
      confirmDeletion,
      finalConfirmDeletion,
      closeModalConfirmation,
      modalDeletion,
      modalMessage,
      modalText,
      modal,
      openModal,
      closeModal,
      modalAccommodation,
      accommodationSuccess,
      isSendingAccommodation,
      isArchivingGdpr,
      accommodationRequestComment,
      isAccommodationRequestEvent,
      accommodationRequestEvent,
      openAccommodationModal,
      closeAccommodationModal,
      resetAccommodationState,
      sendAccommodationRequest,
      modalGdprArchive,
      openGdprArchiveModal,
      closeGdprArchiveModal,
      confirmGdprArchive,
    }
  },
  data() {
    return {
      departements,
      isModifying: false,
    }
  },
  computed: {
    ...mapGetters({
      taxonomies: 'initialData/getTaxonomies',
      user: 'users/currentUser',
    }),
    console() {
      return console
    },
    canModify() {
      if (this.canManageYoungsData) {
        return true
      }
      const youngUsers = Array.isArray(this.young.users) ? this.young.users : []
      const authorizedUsers = new Set(youngUsers.map(userName => userName.toUpperCase()))
      const name = this.user.name.toUpperCase()
      // Check if the user's name is in the Set of authorized users
      return authorizedUsers.has(name)
    },
    canManageYoungsData() {
      return store.getters['users/getUserRole'].includes('Coordinateur')
    },
    canRequestAccommodation() {
      const userRole = store.getters['users/getUserRole']
      return userRole.includes('Coordinateur') || userRole.includes('Ecoutant')
    },
  },
  watch: {
    young: {
      handler() {
        this.isModifying = false
      },
      deep: true,
    },
    shallShowYoungDetailsSidebar: {
      handler() {
        if (!this.shallShowYoungDetailsSidebar) {
          this.isModifying = false
        }
      },
    },
  },
  methods: {
    setIsModifying() {
      this.isModifying = !this.isModifying
    },
    getTaxonomyLabel(taxonomy, propertyValue) {
      return this.taxonomies[taxonomy].find(entry => entry.id === propertyValue)?.label || 'tes'
    },
    hideSideBar() {
      this.$emit('update:shall-show-young-details-sidebar', false)
      this.isModifying = false
    },
  },
}
</script>

<style lang="scss" scoped>
.data-modal {
  &__button {
    margin-top: 4px;
  }

  &__button-remove {
    margin-top: 1rem;
  }

  &__back-button {
    margin-top: 1rem;
  }

  &__delete-confirm {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 1.5rem;
  }
}
</style>
